import axios from "axios";
import { API_BASE } from "@/config";

const client = axios.create({ baseURL: API_BASE, timeout: 120000 });

// POST /api/audits — multipart:
//   file (required) — the bulk .xlsx
//   brand, currency, marketplace, marginPct (optional form fields)
export async function createAudit(file, { brand, currency, marketplace, marginPct } = {}) {
  const fd = new FormData();
  fd.append("file", file);
  if (brand) fd.append("brand", brand);
  if (currency) fd.append("currency", currency);
  if (marketplace) fd.append("marketplace", marketplace);
  if (marginPct != null) fd.append("marginPct", String(marginPct));
  const { data } = await client.post("/api/audits", fd);
  return data;
}

// GET /api/audits/:id → {locked:true, summary} | {audit} | 404
export async function getAudit(auditId) {
  const { data } = await client.get(`/api/audits/${auditId}`);
  return data;
}

// POST /api/audits/:id/unlock {email, firstName?, brandName?} → {audit}
export async function unlockAudit(auditId, payload) {
  const { data } = await client.post(`/api/audits/${auditId}/unlock`, payload);
  return data;
}

// POST /api/audits/:id/confirm-brand {confirm:true} | {brand:"x"} → {audit}
export async function confirmBrand(auditId, payload) {
  const { data } = await client.post(`/api/audits/${auditId}/confirm-brand`, payload);
  return data;
}

export const getProfile = () => {
  try {
    return JSON.parse(localStorage.getItem("ss_profile") || "null");
  } catch {
    return null;
  }
};
export const saveProfile = (p) => localStorage.setItem("ss_profile", JSON.stringify(p));
